import React, { useContext } from "react";
import { Formik, Form } from "formik";
import { Context } from "../inc/state";
import { Radio, FieldWrapper } from "./fields";

export default () => {
	const [state, dispatch, setLoading] = useContext(Context);

	const handleSubmit = (values, { setSubmitting }) => {
		const { fundOption } = state;

		dispatch({ type: "ADD_DATA", payload: { values } });

		if (fundOption == 1) {
			dispatch({ type: "INIT_COMPANIES" });
		}

		if (fundOption == 2) {
			dispatch({ type: "INIT_INDIVIDUALS" });
		}

		if (fundOption == 3) {
			dispatch({ type: "INIT_INDIVIDUALS", count: 2 });
		}

		if (fundOption == 4) {
			dispatch({ type: "INIT_INDIVIDUALS", count: values.individualsCount });
		}

		if (fundOption == 5) {
			dispatch({ type: "INIT_COMPANIES", count: values.companiesCount });
		}

		dispatch({ type: "STEP_FORWARD" });
	};

	const setLegalEntity = (index, fundTitle) => {
		const fundOption = index + 1;
		const isLegalEntity = fundOption === 1 || fundOption === 5;
		const steps = 5;

		dispatch({
			type: "ADD_DATA",
			payload: {
				fundOption,
				fundTitle,
				isLegalEntity,
				steps,
			},
		});
	};

	const legalEntityTypes = [
		{
			value: "Rechtspersoon",
			label: "Investering als rechtspersoon",
		},
		{
			value: "Natuurlijke persoon",
			label: "Investering als natuurlijke persoon",
		},
		{
			value: "Huwelijksgemeenschap",
			label: "Investering als huwelijksgemeenschap",
		},
		{
			value: "Onverdeeldheid",
			label: "Investering als onverdeeldheid",
		},
		{
			value: "Maatschap",
			label: "Investering als maatschap",
		},
	];

	const initialValues = state.values;

	return (
		<Formik initialValues={initialValues} onSubmit={handleSubmit}>
			{({ values, setFieldValue }) => (
				<Form>
					<h4 className="mb-3">Integra III</h4>
					<label htmlFor="legalEntityType.0" className="mb-3">
						In welke hoedanigheid wenst u te investeren?
					</label>

					{legalEntityTypes.map((entity, index) => (
						<Radio
							name="legalEntityType"
							value={entity.value}
							id={`legalEntityType.${index}.name`}
							key={`legalEntityType.${index}.name`}
							label={entity.label}
							required
							onChange={(event) => {
								setLegalEntity(index, entity.label);
								setFieldValue("legalEntityType", event.target.value);
							}}
						/>
					))}

					{state.fundOption === 4 && (
						<div className="mt-4">
							<FieldWrapper
								label="Hoeveel partijen zijn er in de onverdeeldheid?"
								id="individualsCount"
								name="individualsCount"
								type="number"
							/>
						</div>
					)}

					{state.fundOption === 5 && (
						<div className="mt-4">
							<FieldWrapper
								label="Hoeveel maten heeft de maatschap?"
								id="companiesCount"
								name="companiesCount"
								type="number"
							/>
						</div>
					)}

					<button type="submit" className="btn btn-primary mt-3">
						Volgende
					</button>
				</Form>
			)}
		</Formik>
	);
};
